import styled from 'styled-components';

const Button = styled.button`
  border: 1px solid #CF73B2;
  border-radius: 4px;
  background: #fff;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.41px;
  line-height: 14px;
  color: #CF73B2;
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export default Button;